module.exports = __webpack_public_path__ + "img/1.13299560.png";